import { render, staticRenderFns } from "./MatomoVisitsSummary.vue?vue&type=template&id=08f8b864&"
import script from "./MatomoVisitsSummary.vue?vue&type=script&lang=js&"
export * from "./MatomoVisitsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports